"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var threshold_1 = require("./threshold");
var metricValue_1 = require("./metricValue");
exports.MetricBlue = '#2A79AF';
exports.MetricBlueLight = 'rgba(42, 121, 175, 0.4)';
exports.MetricComparisonColor = '#b4b4b4';
exports.MetricsGoodColor = '#15557F';
exports.MetricsNeutralColor = '#333';
exports.MetricsBadColor = '#DE6B36';
exports.getColorFeature = function (features) {
    // tslint:disable-next-line:no-any
    return features.color;
};
exports.defaultColorAccessor = function (_) {
    return exports.MetricsNeutralColor;
};
exports.buildColorAccessor = function (effectiveDefinition) {
    var color = exports.getColorFeature(effectiveDefinition.features);
    if (!color) {
        return exports.defaultColorAccessor;
    }
    var comparisonAccessor = threshold_1.buildFirstThresholdMeasureAccessor(effectiveDefinition);
    if (!comparisonAccessor) {
        return exports.defaultColorAccessor;
    }
    var measureAccessor = metricValue_1.buildMeasureAccessor(effectiveDefinition);
    return function (dataRow) {
        if (!dataRow) {
            return exports.MetricsNeutralColor;
        }
        var measure = measureAccessor(dataRow);
        var comparison = comparisonAccessor(dataRow);
        if (comparison === undefined) {
            return exports.MetricsNeutralColor;
        }
        // future potential transformFunction
        if (measure > comparison) {
            return exports.MetricsGoodColor;
        }
        else if (measure < comparison) {
            return exports.MetricsBadColor;
        }
        else {
            return exports.MetricsNeutralColor;
        }
        // return dataRow[color.colorColumnName] as string; // this is the future
    };
};
//# sourceMappingURL=color.js.map